import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  loading: false,
  error: null,
  subtotal: 0,
  tax: 0,
  taxRate: 0.077, // Default tax rate, will be updated from TaxRate model
  shipping: 0,
  discount: 0,
  total: 0,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action) => {
      const existingItem = state.items.find(
        (item) => item.id === action.payload.id
      );
      if (existingItem) {
        existingItem.quantity += action.payload.quantity || 1;
      } else {
        state.items.push({
          ...action.payload,
          quantity: action.payload.quantity || 1,
        });
      }
      cartSlice.caseReducers.updateTotals(state);
    },
    removeItem: (state, action) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
      cartSlice.caseReducers.updateTotals(state);
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.items.find((item) => item.id === id);
      if (item) {
        item.quantity = quantity;
      }
      cartSlice.caseReducers.updateTotals(state);
    },
    clearCart: (state) => {
      state.items = [];
      cartSlice.caseReducers.updateTotals(state);
    },
    applyDiscount: (state, action) => {
      state.discount = action.payload;
      cartSlice.caseReducers.updateTotals(state);
    },
    updateShipping: (state, action) => {
      state.shipping = action.payload;
      cartSlice.caseReducers.updateTotals(state);
    },
    updateTaxRate: (state, action) => {
      state.taxRate = action.payload;
      cartSlice.caseReducers.updateTotals(state);
    },
    updateTotals: (state) => {
      state.subtotal = state.items.reduce(
        (total, item) => total + item.price * item.quantity,
        0
      );
      const taxableAmount = state.subtotal - state.discount;
      state.tax = parseFloat((taxableAmount * state.taxRate).toFixed(2));
      state.total =
        state.subtotal + state.tax + state.shipping - state.discount;
    },
  },
});

export const {
  addItem,
  removeItem,
  updateQuantity,
  clearCart,
  applyDiscount,
  updateShipping,
  updateTaxRate,
} = cartSlice.actions;

export default cartSlice.reducer;
